import React, { useState } from 'react';
import PropTypes from 'prop-types';

const propTypes = {

}

const defaultProps = {

}

const ProductsInventoryTrail = (props) => {
  return (
    <h1>Work in progress</h1>
  )
};

ProductsInventoryTrail.propTypes = propTypes;
ProductsInventoryTrail.defaultProps = defaultProps;

export default ProductsInventoryTrail;